// extracted by mini-css-extract-plugin
export var aircallIframe = "_lt-3";
export var fabContainer = "_lt-5";
export var fabRinging = "_lt-6";
export var loadingOverlay = "_lt-4";
export var pulse = "_lt-7";
export var widgetContent = "_lt-2";
export var widgetPanel = "_lt-0";
export var widgetPanelExpanded = "_lt-1";